import "./style.css";

export const Hero = () => (
  <main className="hero">
    <div className="hero__content">
      <h1 className="hero__title">
        <span className="hero__title--creative">Creative</span>
        <span className="hero__title--role">Frontend Engineer</span>
      </h1>
    </div>
    <button type="button" className="hero__cta" data-nav-target="about">
      SEE WHAT I DO
    </button>
  </main>
);
